import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getPortfolioGraphRental } from '../portfolioEndpoints'
import { portfolioKeys } from '../portfolioQueryKeys'

// `fiscalYear` ("2025-26"); undefined = the current fiscal year. The previous
// year's series stays on screen while a newly picked year loads.
export function usePortfolioGraphRentalQuery(fiscalYear: MaybeRefOrGetter<string | undefined>) {
  return useQuery({
    queryKey: () => portfolioKeys.graph('rental', toValue(fiscalYear)),
    queryFn: () => getPortfolioGraphRental(toValue(fiscalYear)),
    placeholderData: keepPreviousData,
  })
}
